import appClient from '../../common/services/AppClient';
import { AskAlphaSettingsValues, QuestionResponseDto, InstructWorkflowDto } from '../types';
import { endpoints } from '../../../config';

export default class AskAlphaService {
    async askQuestion(
        message: string,
        packageId: string,
        nodeIds: string[],
        settings: Omit<AskAlphaSettingsValues, 'useContext'>
    ) {
        const url = `${endpoints.manageUrl}chatbot/ask-question`;

        const data = {
            message,
            packageId,
            nodeIds,
            ...settings
        };

        return appClient.post<QuestionResponseDto>(url, data);
    }

    async getInstructWorkflows(projectId: string) {
        const url = endpoints.manageUrl + `projects/${projectId}/instruct-workflows`;

        const resp = await appClient.get<InstructWorkflowDto[]>(url);

        return resp.unwrapOr([]);
    }
}
